import {connect} from '@store/@common';
import {JobId, ModifyJobRequest} from '@store/@types/kpi';
import JobActions from '@store/job/JobActions';

import {JobForm} from './job-form';

const mapActionsToProps = {
  onSubmit: async (data: ModifyJobRequest, id?: JobId) => {
    if (id) {
      await JobActions.updateJob(data, id);
    } else {
      await JobActions.createJob(data);
    }
    await JobActions.getJobsInAccount();
  },
};

export default connect(JobForm, {}, mapActionsToProps);
